var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friend-request-icon"},[_c('span',{staticClass:"icon iconfont icon-bell",staticStyle:{"font-size":"28px"}}),(_vm.unreadCount > 0)?_c('div',{staticClass:"unread-badge"},[_vm._v(_vm._s(_vm.formattedCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }